import React, { forwardRef, useRef } from "react";
import "./index.css";
const ExploreSection = forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="exploreSectionWrap animated-section section"
      id="jobOpening"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="exploreWrap aosAnim">
              <h2 className="titleText">
                <span className="gradientText skyText">Explore</span>, Apply,
                Succeed
              </h2>
              <iframe
                id="myIframe"
                src="https://bizhero.keka.com/careers/jobdetails"
                frameborder="0"
                height="600px"
                width="100%"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ExploreSection;
